import * as React from 'react';
import styled from 'styled-components'
import {mixinBtnSmall, mixinResetBtnCss, mixinBtnBorder, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";
import {Link, LinkProps} from "react-router-dom";

interface IProps
    extends IBtnDefaultProps, LinkProps {
}

const BtnLinkBorderSmallDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<Link {...ButtonProps} />)

};

const BtnLinkBorderSmall = styled(BtnLinkBorderSmallDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnSmall}
    ${mixinBtnBorder}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnLinkBorderSmall;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_link_border_small.tsx